import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('correct-mark-controller', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('correct-mark-controller');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
